/**
 * 充值记录
 */
 import Layout from '../../pages/layout/Frame';

 const rechargeRecordRouter = {
     path: "/rechargeRecord",
     component: Layout,
     meta: {title: '充值记录'},
     name: "rechargeRecord",
     children: [
         {
             path: "/rechargeRecord/index",
             component: () => import('../../pages/rechargeRecord/index'),
             meta: {title: '充值记录',},
             name: 'rechargeRecord',
         },
     ]
 };
 
 export default rechargeRecordRouter
 